import * as api from '../resources/linked-retailers.api';
import actionTypes from './linked-retailers.action-types';

export const fetchLinkedRetailersRequest = () => ({
  type: actionTypes.FETCH_LINKED_RETAILERS_REQUEST,
  name: 'linkedRetailersLoadingStatus',
});

export const fetchLinkedRetailersSuccess = (list, pagination) => ({
  type: actionTypes.FETCH_LINKED_RETAILERS_SUCCESS,
  list,
  pagination,
  name: 'linkedRetailersLoadingStatus',
});

export const fetchLinkedRetailersFailure = () => ({
  type: actionTypes.FETCH_LINKED_RETAILERS_FAILURE,
  name: 'linkedRetailersLoadingStatus',
});

export const fetchLinkedRetailers = (requestParams) => async (dispatch) => {
  try {
    dispatch(fetchLinkedRetailersRequest());
    const { content: list, ...pagination } = await api.fetchLinkedRetailers(requestParams);
    dispatch(fetchLinkedRetailersSuccess(list, pagination));
  } catch (error) {
    console.error('FETCH_LINKED_RETAILERS', error);
    dispatch(fetchLinkedRetailersFailure());
  }
};

export const updateLinkedRetailersRequest = () => ({
  type: actionTypes.UPDATE_LINKED_RETAILERS_REQUEST,
  name: 'linkedRetailersSavingStatus',
});

export const updateLinkedRetailersSuccess = () => ({
  type: actionTypes.UPDATE_LINKED_RETAILERS_SUCCESS,
  name: 'linkedRetailersSavingStatus',
});

export const updateLinkedRetailersFailure = () => ({
  type: actionTypes.UPDATE_LINKED_RETAILERS_FAILURE,
  name: 'linkedRetailersSavingStatus',
});

export const updateLinkedRetailers = (data) => async (dispatch) => {
  try {
    dispatch(updateLinkedRetailersRequest());
    await api.updateLinkedRetailers(data);
    dispatch(updateLinkedRetailersSuccess());
  } catch (error) {
    console.error('UPDATE_LINKED_RETAILERS', error);
    dispatch(updateLinkedRetailersFailure());
  }
};

export const deleteLinkedRetailersRequest = () => ({
  type: actionTypes.DELETE_LINKED_RETAILERS_REQUEST,
  name: 'linkedRetailersSavingStatus',
});

export const deleteLinkedRetailersSuccess = () => ({
  type: actionTypes.DELETE_LINKED_RETAILERS_SUCCESS,
  name: 'linkedRetailersSavingStatus',
});

export const deleteLinkedRetailersFailure = () => ({
  type: actionTypes.DELETE_LINKED_RETAILERS_FAILURE,
  name: 'linkedRetailersSavingStatus',
});

export const deleteLinkedRetailers = (data) => async (dispatch) => {
  try {
    dispatch(deleteLinkedRetailersRequest());
    await api.deleteLinkedRetailers(data);
    dispatch(deleteLinkedRetailersSuccess());
  } catch (error) {
    console.error('DELETE_LINKED_RETAILERS', error);
    dispatch(deleteLinkedRetailersFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/actions/linked-retailers.actions.js